import axios from 'axios';
import auth from '@client/components/auth';

export const useExerciseLibraryModel = () => {
  const addToLibrary = ({
    name,
    description,
  }: {
    name: string;
    description: string;
  }) =>
    axios.post(
      `${import.meta.env.VITE_MUX_API_URL}/exercise-library`,
      {
        name,
        description,
        equipment: [],
      },
      {
        headers: {
          Authorization: auth.getToken(),
        },
      },
    );

  return { addToLibrary };
};
